import { Outlet, ScrollRestoration } from 'react-router'

import { useRouteHandle } from '@/app/routeHandle'
import { Toaster } from '@/components/ui/Toast'
import { StartPrompts } from '@/features/prompts/StartPrompts'

import { BottomNav } from './BottomNav'
import { Header } from './Header'
import { OfflineBanner } from './OfflineBanner'
import styles from './AppShell.module.css'

export function AppShell() {
  const { hideBottomNav, hideSearchBar } = useRouteHandle()
  return (
    <>
      <Header showSearch={!hideSearchBar} />
      <OfflineBanner />
      <main className={hideBottomNav ? styles.main : `${styles.main} ${styles.withNav}`}>
        <Outlet />
      </main>
      {!hideBottomNav && <BottomNav />}
      <Toaster />
      <StartPrompts />
      <ScrollRestoration />
    </>
  )
}
